import Rebase from "re-base";
import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDd7lT-97dgPS8aQlCHWUyQ9enpeAccv04",
    authDomain: "catch-of-the-day-rbh-ef87e.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-rbh-ef87e.firebaseio.com",
});

const base = Rebase.createClass(firebaseApp.database());

// this is a "named export"
export {firebaseApp};

// this is a "default export"
export default base;




// WEBPACK FOOTER //
// ./src/base.js